// extracted by mini-css-extract-plugin
export var author = "style-module--author--9696b";
export var authorImage = "style-module--authorImage--6ad18";
export var authorName = "style-module--authorName--2cf33";
export var authorTitle = "style-module--authorTitle--03ce7";
export var container = "style-module--container--9ca8f";
export var quote = "style-module--quote--f9a5e";
export var quoteMark = "style-module--quoteMark--49bb1";